




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"
import {mixins} from "vue-class-component";
import MonitorMixin from "@/design-system/utilities/MonitorMixin";
import JdhPageSectionNarrow from "@/design-system/patterns/Page/JdhPageSectionNarrow.vue"

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 3.0.0 Added warning when used outside of PageLayout as a direct child.
 * @changelog 4.4.0 Added auto-stacking for narrow layouts.
 * @changelog 4.4.1 Added separator bar for left-right sections.
 * @changelog 4.9.1 Remove top margin of any first-descendant section headings.
 * @changelog $next Removed warning regarding non-PageLayout parent.
 */
@Component({
    components: {JdhPageSectionNarrow}
})
export default class JdsPageSection extends mixins(MonitorMixin) {
    @Prop({default: false, type: Boolean}) fullWidth!: boolean;
    @Prop({default: false, type: Boolean}) borderless!: boolean;
    @Prop({default: null}) layout!: 'equal-columns'|'columns'|null;

    @ActiveInject({from: 'jds.monitor', default: null}) monitor!: Vue;
    @ActiveInject({from: 'jds.page-layout.stack', default: false}) stacking!: boolean;
}
